// This file is auto-generated by scripts/generate-openapi-models.mjs.
// Do not edit manually.

export const OPENAPI_SPEC_VERSION = "3.0.4" as const;
export const OPENAPI_SCHEMA_COUNT = 305 as const;

export type AllowedIps = {
  ip4Addresses?: Array<string> | null;
  ip4Masks?: Array<string> | null;
  ip4Ranges?: Array<string> | null;
};

export type AmountType = "Brutto" | "Netto" | "Vat";

export type ApiError = {
  code: number;
  description: string;
  details?: Array<string> | null;
};

export type ApiRateLimitsOverride = {
  batchSession: ApiRateLimitValuesOverride;
  collectiveIdentifier: ApiRateLimitValuesOverride;
  invoiceDownload: ApiRateLimitValuesOverride;
  invoiceExport: ApiRateLimitValuesOverride;
  invoiceExportStatus: ApiRateLimitValuesOverride;
  invoiceMetadata: ApiRateLimitValuesOverride;
  invoiceSend: ApiRateLimitValuesOverride;
  invoiceStatus: ApiRateLimitValuesOverride;
  onlineSession: ApiRateLimitValuesOverride;
  other: ApiRateLimitValuesOverride;
  sessionInvoiceList: ApiRateLimitValuesOverride;
  sessionList: ApiRateLimitValuesOverride;
  sessionMisc: ApiRateLimitValuesOverride;
};

export type ApiRateLimitValuesOverride = {
  perHour: number;
  perMinute: number;
  perSecond: number;
};

export type AttachmentPermissionGrantRequest = {
  nip: Nip;
};

export type AttachmentPermissionRevokeRequest = {
  expectedEndDate?: string | null;
  nip: Nip;
};

export type AuthenticationChallengeResponse = {
  challenge: Challenge;
  clientIp: string;
  timestamp: string;
  timestampMs: number;
};

export type AuthenticationContextIdentifier = {
  type: AuthenticationContextIdentifierType;
  value: string;
};

export type AuthenticationContextIdentifierType = "InternalId" | "Nip" | "NipVatUe" | "PeppolId";

export type AuthenticationInitResponse = {
  authenticationToken: TokenInfo;
  referenceNumber: ReferenceNumber;
};

export type AuthenticationListItem = {
  authenticationMethod: AuthenticationMethod;
  authenticationMethodInfo: AuthenticationMethodInfo;
  isCurrent?: boolean;
  isTokenRedeemed?: boolean | null;
  lastTokenRefreshDate?: string | null;
  referenceNumber: ReferenceNumber;
  refreshTokenValidUntil?: string | null;
  startDate: string;
  status: StatusInfo;
};

export type AuthenticationListResponse = {
  continuationToken?: string | null;
  items: Array<AuthenticationListItem>;
};

export type AuthenticationMethod = "InternalCertificate" | "PeppolSignature" | "PersonalSignature" | "QualifiedSeal" | "QualifiedSignature" | "Token" | "TrustedProfile";

export type AuthenticationMethodCategory = "NationalNode" | "Other" | "Token" | "XadesSignature";

export type AuthenticationMethodInfo = {
  category: AuthenticationMethodCategory;
  code: string;
  displayName: string;
};

export type AuthenticationOperationStatusResponse = {
  authenticationMethod: AuthenticationMethod;
  authenticationMethodInfo: AuthenticationMethodInfo;
  isTokenRedeemed?: boolean | null;
  lastTokenRefreshDate?: string | null;
  refreshTokenValidUntil?: string | null;
  startDate: string;
  status: StatusInfo;
};

export type AuthenticationTokenRefreshResponse = {
  accessToken: TokenInfo;
};

export type AuthenticationTokensResponse = {
  accessToken: TokenInfo;
  refreshToken: TokenInfo;
};

export type AuthenticationTokenStatus = "Active" | "Failed" | "Pending" | "Revoked" | "Revoking";

export type AuthorizationPolicy = {
  allowedIps?: AllowedIps | null;
};

export type BadRequestProblemDetails = {
  detail: string;
  errors: Array<ApiError>;
  instance: string;
  status: number;
  timestamp: string;
  title: string;
  traceId: string;
};

export type BatchFileInfo = {
  compressionType?: CompressionType | null;
  fileHash: Sha256HashBase64;
  fileParts: Array<BatchFilePartInfo>;
  fileSize: number;
};

export type BatchFilePartInfo = {
  fileHash: Sha256HashBase64;
  fileSize: number;
  ordinalNumber: number;
};

export type BatchSessionContextLimitsOverride = {
  maxInvoices: number;
  maxInvoiceSizeInMB: number;
  maxInvoiceWithAttachmentSizeInMB: number;
};

export type BatchSessionEffectiveContextLimits = {
  maxInvoices: number;
  maxInvoiceSizeInMB: number;
  maxInvoiceWithAttachmentSizeInMB: number;
};

export type BlockContextAuthenticationRequest = {
  contextIdentifier?: TestDataAuthenticationContextIdentifier | null;
};

export type BuyerIdentifierType = "Nip" | "None" | "Other" | "VatUe";

export type CertificateEffectiveSubjectLimits = {
  maxCertificates?: number;
};

export type CertificateEnrollmentDataResponse = {
  commonName: string;
  countryName: string;
  givenName?: string | null;
  organizationIdentifier?: string | null;
  organizationName?: string | null;
  serialNumber?: string | null;
  surname?: string | null;
  uniqueIdentifier?: string | null;
};

export type CertificateEnrollmentStatusResponse = {
  certificateSerialNumber?: string | null;
  requestDate: string;
  status: StatusInfo;
};

export type CertificateLimit = {
  limit: number;
  remaining: number;
};

export type CertificateLimitsResponse = {
  canRequest: boolean;
  certificate: CertificateLimit;
  enrollment: CertificateLimit;
};

export type CertificateListItem = {
  certificateSerialNumber: string;
  commonName: string;
  lastUseDate?: string | null;
  name: string;
  requestDate: string;
  status: CertificateListItemStatus;
  subjectIdentifier: CertificateSubjectIdentifier;
  type: KsefCertificateType;
  validFrom: string;
  validTo: string;
};

export type CertificateListItemStatus = "Active" | "Blocked" | "Expired" | "Revoked";

export type CertificateRevocationReason = "KeyCompromise" | "Superseded" | "Unspecified";

export type CertificateSubjectIdentifier = {
  type: CertificateSubjectIdentifierType;
  value: string;
};

export type CertificateSubjectIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type CertificateSubjectLimitsOverride = {
  maxCertificates?: number | null;
};

export type Challenge = string;

export type CheckAttachmentPermissionStatusResponse = {
  isAttachmentAllowed?: boolean;
  revokedDate?: string | null;
};

export type CollectiveIdentifierContextLimitsOverride = {
  maxInvoices: number;
};

export type CollectiveIdentifierEffectiveContextLimits = {
  maxInvoices: number;
};

export type CollectiveIdentifierInvoice = {
  description?: string | null;
  ksefNumber: KsefNumber;
  payment?: CollectiveIdentifierInvoicePayment | null;
};

export type CollectiveIdentifierInvoicePayment = {
  amount: number;
  currency: CurrencyCode;
};

export type CollectiveIdentifierInvoicesQueryRequest = {
  collectiveIdentifierNumbers: Array<string>;
};

export type CollectiveIdentifierInvoicesQueryResponse = {
  continuationToken?: string | null;
  invoices: Array<CollectiveIdentifierInvoicesQueryResponseItem>;
};

export type CollectiveIdentifierInvoicesQueryResponseItem = {
  collectiveIdentifierNumber: string;
  description?: string | null;
  detailsHidden: boolean;
  ksefNumber: KsefNumber;
  payment?: CollectiveIdentifierInvoicesQueryResponseItemPayment | null;
};

export type CollectiveIdentifierInvoicesQueryResponseItemPayment = {
  amount: number;
  currency: string;
};

export type CollectiveIdentifiersByKsefNumberQueryResponse = {
  collectiveIdentifiers: Array<CollectiveIdentifiersByKsefNumberQueryResponseItem>;
  continuationToken?: string | null;
};

export type CollectiveIdentifiersByKsefNumberQueryResponseItem = {
  collectiveIdentifierNumber: string;
  createdInCurrentContext: boolean;
  dateCreated: string;
};

export type CollectiveIdentifiersQueryRequest = {
  collectiveIdentifierNumber?: string | null;
  createdInCurrentContext?: boolean | null;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  invoiceCountFrom?: number | null;
  invoiceCountTo?: number | null;
};

export type CollectiveIdentifiersQueryResponse = {
  collectiveIdentifiers: Array<CollectiveIdentifiersQueryResponseItem>;
  continuationToken?: string | null;
};

export type CollectiveIdentifiersQueryResponseItem = {
  collectiveIdentifierNumber: string;
  createdInCurrentContext: boolean;
  dateCreated: string;
  invoiceCount: number;
};

export type CommonSessionStatus = "Cancelled" | "Failed" | "InProgress" | "Succeeded";

export type CompressionType = "TarGz" | "Zip";

export type CurrencyCode = "AED" | "AFN" | "ALL" | "AMD" | "ANG" | "AOA" | "ARS" | "AUD" | "AWG" | "AZN" | "BAM" | "BBD" | "BDT" | "BGN" | "BHD" | "BIF" | "BMD" | "BND" | "BOB" | "BOV" | "BRL" | "BSD" | "BTN" | "BWP" | "BYN" | "BZD" | "CAD" | "CDF" | "CHE" | "CHF" | "CHW" | "CLF" | "CLP" | "CNY" | "COP" | "COU" | "CRC" | "CUC" | "CUP" | "CVE" | "CZK" | "DJF" | "DKK" | "DOP" | "DZD" | "EGP" | "ERN" | "ETB" | "EUR" | "FJD" | "FKP" | "GBP" | "GEL" | "GGP" | "GHS" | "GIP" | "GMD" | "GNF" | "GTQ" | "GYD" | "HKD" | "HNL" | "HRK" | "HTG" | "HUF" | "IDR" | "ILS" | "IMP" | "INR" | "IQD" | "IRR" | "ISK" | "JEP" | "JMD" | "JOD" | "JPY" | "KES" | "KGS" | "KHR" | "KMF" | "KPW" | "KRW" | "KWD" | "KYD" | "KZT" | "LAK" | "LBP" | "LKR" | "LRD" | "LSL" | "LYD" | "MAD" | "MDL" | "MGA" | "MKD" | "MMK" | "MNT" | "MOP" | "MRU" | "MUR" | "MVR" | "MWK" | "MXN" | "MXV" | "MYR" | "MZN" | "NAD" | "NGN" | "NIO" | "NOK" | "NPR" | "NZD" | "OMR" | "PAB" | "PEN" | "PGK" | "PHP" | "PKR" | "PLN" | "PYG" | "QAR" | "RON" | "RSD" | "RUB" | "RWF" | "SAR" | "SBD" | "SCR" | "SDG" | "SEK" | "SGD" | "SHP" | "SLL" | "SOS" | "SRD" | "SSP" | "STN" | "SVC" | "SYP" | "SZL" | "THB" | "TJS" | "TMT" | "TND" | "TOP" | "TRY" | "TTD" | "TWD" | "TZS" | "UAH" | "UGX" | "USD" | "USN" | "UYI" | "UYU" | "UYW" | "UZS" | "VES" | "VND" | "VUV" | "WST" | "XAF" | "XAG" | "XAU" | "XBA" | "XBB" | "XBC" | "XBD" | "XCD" | "XCG" | "XDR" | "XOF" | "XPD" | "XPF" | "XPT" | "XSU" | "XUA" | "XXX" | "YER" | "ZAR" | "ZMW" | "ZWL";

export type EffectiveApiRateLimits = {
  batchSession: EffectiveApiRateLimitValues;
  collectiveIdentifier: EffectiveApiRateLimitValues;
  invoiceDownload: EffectiveApiRateLimitValues;
  invoiceExport: EffectiveApiRateLimitValues;
  invoiceExportStatus: EffectiveApiRateLimitValues;
  invoiceMetadata: EffectiveApiRateLimitValues;
  invoiceSend: EffectiveApiRateLimitValues;
  invoiceStatus: EffectiveApiRateLimitValues;
  onlineSession: EffectiveApiRateLimitValues;
  other: EffectiveApiRateLimitValues;
  sessionInvoiceList: EffectiveApiRateLimitValues;
  sessionList: EffectiveApiRateLimitValues;
  sessionMisc: EffectiveApiRateLimitValues;
};

export type EffectiveApiRateLimitValues = {
  perHour: number;
  perMinute: number;
  perSecond: number;
};

export type EffectiveContextLimits = {
  batchSession: BatchSessionEffectiveContextLimits;
  collectiveIdentifier: CollectiveIdentifierEffectiveContextLimits;
  onlineSession: OnlineSessionEffectiveContextLimits;
};

export type EffectiveSubjectLimits = {
  certificate?: CertificateEffectiveSubjectLimits | null;
  enrollment?: EnrollmentEffectiveSubjectLimits | null;
};

export type EncryptionInfo = {
  encryptedSymmetricKey: string;
  initializationVector: string;
  publicKeyId?: string | null;
};

export type EnrollCertificateRequest = {
  certificateName: string;
  certificateType: KsefCertificateType;
  csr: string;
  validFrom?: string | null;
};

export type EnrollCertificateResponse = {
  referenceNumber: ReferenceNumber;
  timestamp: string;
};

export type EnrollmentEffectiveSubjectLimits = {
  maxEnrollments?: number;
};

export type EnrollmentSubjectLimitsOverride = {
  maxEnrollments?: number | null;
};

export type EntityAuthorizationGrant = {
  authorIdentifier?: EntityAuthorizationsAuthorIdentifier | null;
  authorizationScope: InvoicePermissionType;
  authorizedEntityIdentifier: EntityAuthorizationsAuthorizedEntityIdentifier;
  authorizingEntityIdentifier: EntityAuthorizationsAuthorizingEntityIdentifier;
  description: string;
  id: PermissionId;
  startDate: string;
  subjectEntityDetails?: PermissionsSubjectEntityByIdentifierDetails | null;
};

export type EntityAuthorizationPermissionsGrantRequest = {
  description: string;
  permission: EntityAuthorizationPermissionType;
  subjectDetails: EntityDetails;
  subjectIdentifier: EntityAuthorizationPermissionsSubjectIdentifier;
};

export type EntityAuthorizationPermissionsQueryRequest = {
  authorizedIdentifier?: EntityAuthorizationsAuthorizedEntityIdentifier | null;
  authorizingIdentifier?: EntityAuthorizationsAuthorizingEntityIdentifier | null;
  permissionTypes?: Array<InvoicePermissionType> | null;
  queryType: QueryType;
};

export type EntityAuthorizationPermissionsSubjectIdentifier = {
  type: EntityAuthorizationPermissionsSubjectIdentifierType;
  value: string;
};

export type EntityAuthorizationPermissionsSubjectIdentifierType = "Nip" | "PeppolId";

export type EntityAuthorizationPermissionType = "PefInvoicing" | "RRInvoicing" | "SelfInvoicing" | "TaxRepresentative";

export type EntityAuthorizationsAuthorIdentifier = {
  type: EntityAuthorizationsAuthorIdentifierType;
  value: string;
};

export type EntityAuthorizationsAuthorIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type EntityAuthorizationsAuthorizedEntityIdentifier = {
  type: EntityAuthorizationsAuthorizedEntityIdentifierType;
  value: string;
};

export type EntityAuthorizationsAuthorizedEntityIdentifierType = "Nip" | "PeppolId";

export type EntityAuthorizationsAuthorizingEntityIdentifier = {
  type: EntityAuthorizationsAuthorizingEntityIdentifierType;
  value: string;
};

export type EntityAuthorizationsAuthorizingEntityIdentifierType = "Nip";

export type EntityByFingerprintDetails = {
  address: string;
  fullName: string;
};

export type EntityDetails = {
  fullName: string;
};

export type EntityPermission = {
  canDelegate?: boolean;
  type: EntityPermissionType;
};

export type EntityPermissionItem = {
  canDelegate: boolean;
  contextIdentifier: EntityPermissionsContextIdentifier;
  description: string;
  id: PermissionId;
  permissionScope: EntityPermissionItemScope;
  startDate: string;
};

export type EntityPermissionItemScope = "InvoiceRead" | "InvoiceWrite";

export type EntityPermissionsContextIdentifier = {
  type: EntityPermissionsContextIdentifierType;
  value: string;
};

export type EntityPermissionsContextIdentifierType = "InternalId" | "Nip";

export type EntityPermissionsGrantRequest = {
  description: string;
  permissions: Array<EntityPermission>;
  subjectDetails: EntityDetails;
  subjectIdentifier: EntityPermissionsSubjectIdentifier;
};

export type EntityPermissionsQueryRequest = {
  contextIdentifier?: EntityPermissionsContextIdentifier | null;
};

export type EntityPermissionsSubjectIdentifier = {
  type: EntityPermissionsSubjectIdentifierType;
  value: string;
};

export type EntityPermissionsSubjectIdentifierType = "Nip";

export type EntityPermissionsSubordinateEntityIdentifier = {
  type: EntityPermissionsSubordinateEntityIdentifierType;
  value: string;
};

export type EntityPermissionsSubordinateEntityIdentifierType = "Nip";

export type EntityPermissionType = "InvoiceRead" | "InvoiceWrite";

export type EntityRole = {
  description: string;
  parentEntityIdentifier?: EntityRolesParentEntityIdentifier | null;
  role: EntityRoleType;
  startDate: string;
};

export type EntityRolesParentEntityIdentifier = {
  type: EntityRolesParentEntityIdentifierType;
  value: string;
};

export type EntityRolesParentEntityIdentifierType = "Nip";

export type EntityRoleType = "CourtBailiff" | "EnforcementAuthority" | "LocalGovernmentSubUnit" | "LocalGovernmentUnit" | "VatGroupSubUnit" | "VatGroupUnit";

export type EntitySubjectByFingerprintDetailsType = "EntityByFingerprint";

export type EntitySubjectByIdentifierDetailsType = "EntityByIdentifier";

export type EntitySubjectDetailsType = "EntityByFingerprint" | "EntityByIdentifier";

export type EuEntityAdministrationPermissionsContextIdentifier = {
  type: EuEntityAdministrationPermissionsContextIdentifierType;
  value: string;
};

export type EuEntityAdministrationPermissionsContextIdentifierType = "NipVatUe";

export type EuEntityAdministrationPermissionsGrantRequest = {
  contextIdentifier: EuEntityAdministrationPermissionsContextIdentifier;
  description: string;
  euEntityDetails: EuEntityDetails;
  euEntityName: string;
  subjectDetails: EuEntityPermissionSubjectDetails;
  subjectIdentifier: EuEntityAdministrationPermissionsSubjectIdentifier;
};

export type EuEntityAdministrationPermissionsSubjectIdentifier = {
  type: EuEntityAdministrationPermissionsSubjectIdentifierType;
  value: string;
};

export type EuEntityAdministrationPermissionsSubjectIdentifierType = "Fingerprint";

export type EuEntityDetails = {
  address: string;
  fullName: string;
};

export type EuEntityPermission = {
  authorIdentifier: EuEntityPermissionsAuthorIdentifier;
  authorizedFingerprintIdentifier: string;
  description: string;
  euEntityDetails?: PermissionsEuEntityDetails | null;
  euEntityName: string;
  id: PermissionId;
  permissionScope: EuEntityPermissionsQueryPermissionType;
  startDate: string;
  subjectEntityDetails?: PermissionsSubjectEntityByFingerprintDetails | null;
  subjectPersonDetails?: PermissionsSubjectPersonByFingerprintDetails | null;
  vatUeIdentifier: string;
};

export type EuEntityPermissionsAuthorIdentifier = {
  type: EuEntityPermissionsAuthorIdentifierType;
  value: string;
};

export type EuEntityPermissionsAuthorIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type EuEntityPermissionsGrantRequest = {
  description: string;
  permissions: Array<EuEntityPermissionType>;
  subjectDetails: EuEntityPermissionSubjectDetails;
  subjectIdentifier: EuEntityPermissionsSubjectIdentifier;
};

export type EuEntityPermissionsQueryPermissionType = "Introspection" | "InvoiceRead" | "InvoiceWrite" | "VatUeManage";

export type EuEntityPermissionsQueryRequest = {
  authorizedFingerprintIdentifier?: string | null;
  permissionTypes?: Array<EuEntityPermissionsQueryPermissionType> | null;
  vatUeIdentifier?: string | null;
};

export type EuEntityPermissionsSubjectIdentifier = {
  type: EuEntityPermissionsSubjectIdentifierType;
  value: string;
};

export type EuEntityPermissionsSubjectIdentifierType = "Fingerprint";

export type EuEntityPermissionSubjectDetails = {
  entityByFp?: EntityByFingerprintDetails | null;
  personByFpNoId?: PersonByFingerprintWithoutIdentifierDetails | null;
  personByFpWithId?: PersonByFingerprintWithIdentifierDetails | null;
  subjectDetailsType: EuEntityPermissionSubjectDetailsType;
};

export type EuEntityPermissionSubjectDetailsType = "EntityByFingerprint" | "PersonByFingerprintWithIdentifier" | "PersonByFingerprintWithoutIdentifier";

export type EuEntityPermissionType = "InvoiceRead" | "InvoiceWrite";

export type ExceptionDetails = {
  details?: Array<string> | null;
  exceptionCode?: number;
  exceptionDescription?: string | null;
};

export type ExceptionInfo = {
  exceptionDetailList?: Array<ExceptionDetails> | null;
  referenceNumber?: ReferenceNumber | null;
  serviceCode?: string | null;
  serviceCtx?: string | null;
  serviceName?: string | null;
  timestamp?: string;
};

export type ExceptionResponse = {
  exception?: ExceptionInfo | null;
};

export type ExportInvoicesResponse = {
  referenceNumber: ReferenceNumber;
};

export type ForbiddenProblemDetails = {
  detail: string;
  instance?: string | null;
  reasonCode: string;
  security?: Record<string, unknown | null> | null;
  status: number;
  timestamp: string;
  title: string;
  traceId?: string | null;
};

export type FormCode = {
  schemaVersion: string;
  systemCode: string;
  value: string;
};

export type GenerateCollectiveIdentifierRequest = {
  invoices: Array<CollectiveIdentifierInvoice>;
};

export type GenerateCollectiveIdentifierResponse = {
  collectiveIdentifierNumber: string;
};

export type GenerateTokenRequest = {
  description: string;
  permissions: Array<TokenPermissionType>;
};

export type GenerateTokenResponse = {
  referenceNumber: ReferenceNumber;
  token: string;
};

export type GoneProblemDetails = {
  detail: string;
  instance: string;
  status: number;
  timestamp: string;
  title: string;
  traceId: string;
};

export type IdDocument = {
  country: string;
  number: string;
  type: string;
};

export type IndirectPermissionsGrantRequest = {
  description: string;
  permissions: Array<IndirectPermissionType>;
  subjectDetails: PersonPermissionSubjectDetails;
  subjectIdentifier: IndirectPermissionsSubjectIdentifier;
  targetIdentifier?: IndirectPermissionsTargetIdentifier | null;
};

export type IndirectPermissionsSubjectIdentifier = {
  type: IndirectPermissionsSubjectIdentifierType;
  value: string;
};

export type IndirectPermissionsSubjectIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type IndirectPermissionsTargetIdentifier = {
  type: IndirectPermissionsTargetIdentifierType;
  value?: string | null;
};

export type IndirectPermissionsTargetIdentifierType = "AllPartners" | "InternalId" | "Nip";

export type IndirectPermissionType = "InvoiceRead" | "InvoiceWrite";

export type InitTokenAuthenticationRequest = {
  authorizationPolicy?: AuthorizationPolicy | null;
  challenge: Challenge;
  contextIdentifier: AuthenticationContextIdentifier;
  encryptedToken: string;
  publicKeyId?: string | null;
};

export type InternalId = string;

export type InvoiceExportRequest = {
  compressionType?: CompressionType | null;
  encryption: EncryptionInfo;
  filters: InvoiceQueryFilters;
  onlyMetadata?: boolean;
};

export type InvoiceExportStatusResponse = {
  completedDate?: string | null;
  package?: InvoicePackage | null;
  packageExpirationDate?: string | null;
  status: StatusInfo;
};

export type InvoiceMetadata = {
  acquisitionDate: string;
  authorizedSubject?: InvoiceMetadataAuthorizedSubject | null;
  buyer: InvoiceMetadataBuyer;
  currency: string;
  formCode: FormCode;
  grossAmount: number;
  hasAttachment: boolean;
  hashOfCorrectedInvoice?: Sha256HashBase64 | null;
  invoiceHash: Sha256HashBase64;
  invoiceNumber: string;
  invoiceType: InvoiceType;
  invoicingDate: string;
  invoicingMode: InvoicingMode;
  isSelfInvoicing: boolean;
  issueDate: string;
  ksefNumber: KsefNumber;
  netAmount: number;
  permanentStorageDate: string;
  seller: InvoiceMetadataSeller;
  thirdSubjects?: Array<InvoiceMetadataThirdSubject> | null;
  vatAmount: number;
};

export type InvoiceMetadataAuthorizedSubject = {
  name?: string | null;
  nip: Nip;
  role: number;
};

export type InvoiceMetadataBuyer = {
  identifier: InvoiceMetadataBuyerIdentifier;
  name?: string | null;
};

export type InvoiceMetadataBuyerIdentifier = {
  type: BuyerIdentifierType;
  value?: string | null;
};

export type InvoiceMetadataSeller = {
  name?: string | null;
  nip: Nip;
};

export type InvoiceMetadataThirdSubject = {
  identifier: InvoiceMetadataThirdSubjectIdentifier;
  name?: string | null;
  role: number;
};

export type InvoiceMetadataThirdSubjectIdentifier = {
  type: ThirdSubjectIdentifierType;
  value?: string | null;
};

export type InvoicePackage = {
  compressionType: CompressionType;
  invoiceCount: number;
  isTruncated: boolean;
  lastInvoicingDate?: string | null;
  lastIssueDate?: string | null;
  lastPermanentStorageDate?: string | null;
  parts: Array<InvoicePackagePart>;
  permanentStorageHwmDate?: string | null;
  size: number;
};

export type InvoicePackagePart = {
  encryptedPartHash: Sha256HashBase64;
  encryptedPartSize: number;
  expirationDate: string;
  method: string;
  ordinalNumber: number;
  partHash: Sha256HashBase64;
  partName: string;
  partSize: number;
  url: string;
};

export type InvoicePermissionType = "PefInvoicing" | "RRInvoicing" | "SelfInvoicing" | "TaxRepresentative";

export type InvoiceQueryAmount = {
  from?: number | null;
  to?: number | null;
  type: AmountType;
};

export type InvoiceQueryBuyerIdentifier = {
  type: BuyerIdentifierType;
  value?: string | null;
};

export type InvoiceQueryDateRange = {
  dateType: InvoiceQueryDateType;
  from: string;
  restrictToPermanentStorageHwmDate?: boolean | null;
  to?: string | null;
};

export type InvoiceQueryDateType = "Invoicing" | "Issue" | "PermanentStorage";

export type InvoiceQueryFilters = {
  amount?: InvoiceQueryAmount | null;
  buyerIdentifier?: InvoiceQueryBuyerIdentifier | null;
  currencyCodes?: Array<CurrencyCode> | null;
  dateRange: InvoiceQueryDateRange;
  formType?: InvoiceQueryFormType | null;
  hasAttachment?: boolean | null;
  invoiceNumber?: string | null;
  invoiceTypes?: Array<InvoiceType> | null;
  invoicingMode?: InvoicingMode | null;
  isSelfInvoicing?: boolean | null;
  ksefNumber?: KsefNumber | null;
  sellerNip?: Nip | null;
  subjectType: InvoiceQuerySubjectType;
};

export type InvoiceQueryFormType = "FA_RR" | "FA" | "PEF";

export type InvoiceQuerySubjectType = "Subject1" | "Subject2" | "Subject3" | "SubjectAuthorized";

export type InvoiceStatusInfo = {
  code: number;
  description: string;
  details?: Array<string> | null;
  extensions?: Record<string, string | null> | null;
};

export type InvoiceType = "Kor" | "KorPef" | "KorRoz" | "KorVatRr" | "KorZal" | "Roz" | "Upr" | "Vat" | "VatPef" | "VatPefSp" | "VatRr" | "Zal";

export type InvoicingMode = "Offline" | "Online";

export type KsefCertificateType = "Authentication" | "Offline";

export type KsefNumber = string;

export type Nip = string;

export type NipVatUe = string;

export type OnlineSessionContextLimitsOverride = {
  maxInvoices: number;
  maxInvoiceSizeInMB: number;
  maxInvoiceWithAttachmentSizeInMB: number;
};

export type OnlineSessionEffectiveContextLimits = {
  maxInvoices: number;
  maxInvoiceSizeInMB: number;
  maxInvoiceWithAttachmentSizeInMB: number;
};

export type OpenBatchSessionRequest = {
  batchFile: BatchFileInfo;
  encryption: EncryptionInfo;
  formCode: FormCode;
  offlineMode?: boolean;
};

export type OpenBatchSessionResponse = {
  partUploadRequests: Array<PartUploadRequest>;
  referenceNumber: ReferenceNumber;
};

export type OpenOnlineSessionRequest = {
  encryption: EncryptionInfo;
  formCode: FormCode;
};

export type OpenOnlineSessionResponse = {
  referenceNumber: ReferenceNumber;
  validUntil: string;
};

export type PartUploadRequest = {
  headers: Record<string, string | null>;
  method: string;
  ordinalNumber: number;
  url: string;
};

export type PeppolId = string;

export type PeppolProvider = {
  dateCreated: string;
  id: PeppolId;
  name: string;
};

export type PermissionId = string;

export type PermissionsEuEntityDetails = {
  address: string;
  fullName: string;
};

export type PermissionsOperationResponse = {
  referenceNumber: ReferenceNumber;
};

export type PermissionsOperationStatusResponse = {
  status: StatusInfo;
};

export type PermissionsSubjectEntityByFingerprintDetails = {
  address?: string | null;
  fullName: string;
  subjectDetailsType: EntitySubjectByFingerprintDetailsType;
};

export type PermissionsSubjectEntityByIdentifierDetails = {
  fullName: string;
  subjectDetailsType: EntitySubjectByIdentifierDetailsType;
};

export type PermissionsSubjectEntityDetails = {
  address?: string | null;
  fullName: string;
  subjectDetailsType: EntitySubjectDetailsType;
};

export type PermissionsSubjectPersonByFingerprintDetails = {
  birthDate?: string | null;
  firstName: string;
  idDocument?: IdDocument | null;
  lastName: string;
  personIdentifier?: PersonIdentifier | null;
  subjectDetailsType: PersonSubjectByFingerprintDetailsType;
};

export type PermissionsSubjectPersonDetails = {
  birthDate?: string | null;
  firstName: string;
  idDocument?: IdDocument | null;
  lastName: string;
  personIdentifier?: PersonIdentifier | null;
  subjectDetailsType: PersonSubjectDetailsType;
};

export type PermissionState = "Active" | "Inactive";

export type PersonalPermission = {
  authorizedIdentifier?: PersonalPermissionsAuthorizedIdentifier | null;
  canDelegate: boolean;
  contextIdentifier?: PersonalPermissionsContextIdentifier | null;
  description: string;
  id: PermissionId;
  permissionScope: PersonalPermissionScope;
  permissionState: PermissionState;
  startDate: string;
  subjectEntityDetails?: PermissionsSubjectEntityDetails | null;
  subjectPersonDetails?: PermissionsSubjectPersonDetails | null;
  targetIdentifier?: PersonalPermissionsTargetIdentifier | null;
};

export type PersonalPermissionsAuthorizedIdentifier = {
  type: PersonalPermissionsAuthorizedIdentifierType;
  value: string;
};

export type PersonalPermissionsAuthorizedIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type PersonalPermissionsContextIdentifier = {
  type: PersonalPermissionsContextIdentifierType;
  value: string;
};

export type PersonalPermissionsContextIdentifierType = "InternalId" | "Nip";

export type PersonalPermissionScope = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage" | "VatUeManage";

export type PersonalPermissionsQueryRequest = {
  contextIdentifier?: PersonalPermissionsContextIdentifier | null;
  permissionState?: PermissionState | null;
  permissionTypes?: Array<PersonalPermissionType> | null;
  targetIdentifier?: PersonalPermissionsTargetIdentifier | null;
};

export type PersonalPermissionsTargetIdentifier = {
  type: PersonalPermissionsTargetIdentifierType;
  value?: string | null;
};

export type PersonalPermissionsTargetIdentifierType = "AllPartners" | "InternalId" | "Nip";

export type PersonalPermissionType = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage" | "VatUeManage";

export type PersonByFingerprintWithIdentifierDetails = {
  firstName: string;
  identifier: PersonIdentifier;
  lastName: string;
};

export type PersonByFingerprintWithoutIdentifierDetails = {
  birthDate: string;
  firstName: string;
  idDocument: IdDocument;
  lastName: string;
};

export type PersonCreateRequest = {
  createdDate?: string | null;
  description: string;
  isBailiff: boolean;
  isDeceased?: boolean;
  nip: Nip;
  pesel: Pesel;
};

export type PersonDetails = {
  firstName: string;
  lastName: string;
};

export type PersonIdentifier = {
  type: PersonIdentifierType;
  value: string;
};

export type PersonIdentifierType = "Nip" | "Pesel";

export type PersonPermission = {
  authorIdentifier: PersonPermissionsAuthorIdentifier;
  authorizedIdentifier: PersonPermissionsAuthorizedIdentifier;
  canDelegate: boolean;
  contextIdentifier?: PersonPermissionsContextIdentifier | null;
  description: string;
  id: PermissionId;
  permissionScope: PersonPermissionScope;
  permissionState: PermissionState;
  startDate: string;
  subjectEntityDetails?: PermissionsSubjectEntityDetails | null;
  subjectPersonDetails?: PermissionsSubjectPersonDetails | null;
  targetIdentifier?: PersonPermissionsTargetIdentifier | null;
};

export type PersonPermissionsAuthorIdentifier = {
  type: PersonPermissionsAuthorIdentifierType;
  value?: string | null;
};

export type PersonPermissionsAuthorIdentifierType = "Fingerprint" | "Nip" | "Pesel" | "System";

export type PersonPermissionsAuthorizedIdentifier = {
  type: PersonPermissionsAuthorizedIdentifierType;
  value: string;
};

export type PersonPermissionsAuthorizedIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type PersonPermissionsContextIdentifier = {
  type: PersonPermissionsContextIdentifierType;
  value: string;
};

export type PersonPermissionsContextIdentifierType = "InternalId" | "Nip";

export type PersonPermissionScope = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage";

export type PersonPermissionsGrantRequest = {
  description: string;
  permissions: Array<PersonPermissionType>;
  subjectDetails: PersonPermissionSubjectDetails;
  subjectIdentifier: PersonPermissionsSubjectIdentifier;
};

export type PersonPermissionsQueryRequest = {
  authorIdentifier?: PersonPermissionsAuthorIdentifier | null;
  authorizedIdentifier?: PersonPermissionsAuthorizedIdentifier | null;
  contextIdentifier?: PersonPermissionsContextIdentifier | null;
  permissionState?: PermissionState | null;
  permissionTypes?: Array<PersonPermissionType> | null;
  queryType: PersonPermissionsQueryType;
  targetIdentifier?: PersonPermissionsTargetIdentifier | null;
};

export type PersonPermissionsQueryType = "PermissionsGrantedInCurrentContext" | "PermissionsInCurrentContext";

export type PersonPermissionsSubjectIdentifier = {
  type: PersonPermissionsSubjectIdentifierType;
  value: string;
};

export type PersonPermissionsSubjectIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type PersonPermissionsTargetIdentifier = {
  type: PersonPermissionsTargetIdentifierType;
  value?: string | null;
};

export type PersonPermissionsTargetIdentifierType = "AllPartners" | "InternalId" | "Nip";

export type PersonPermissionSubjectDetails = {
  personByFpNoId?: PersonByFingerprintWithoutIdentifierDetails | null;
  personByFpWithId?: PersonByFingerprintWithIdentifierDetails | null;
  personById?: PersonDetails | null;
  subjectDetailsType: PersonPermissionSubjectDetailsType;
};

export type PersonPermissionSubjectDetailsType = "PersonByFingerprintWithIdentifier" | "PersonByFingerprintWithoutIdentifier" | "PersonByIdentifier";

export type PersonPermissionType = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage";

export type PersonRemoveRequest = {
  nip: Nip;
};

export type PersonSubjectByFingerprintDetailsType = "PersonByFingerprintWithIdentifier" | "PersonByFingerprintWithoutIdentifier";

export type PersonSubjectDetailsType = "PersonByFingerprintWithIdentifier" | "PersonByFingerprintWithoutIdentifier" | "PersonByIdentifier";

export type Pesel = string;

export type PublicKeyCertificate = {
  certificate: string;
  certificateId: string;
  publicKeyId: string;
  usage: Array<PublicKeyCertificateUsage>;
  validFrom: string;
  validTo: string;
};

export type PublicKeyCertificateUsage = "KsefTokenEncryption" | "SymmetricKeyEncryption";

export type QueryCertificatesRequest = {
  certificateSerialNumber?: string | null;
  expiresAfter?: string | null;
  name?: string | null;
  status?: CertificateListItemStatus | null;
  type?: KsefCertificateType | null;
};

export type QueryCertificatesResponse = {
  certificates: Array<CertificateListItem>;
  hasMore: boolean;
};

export type QueryEntityAuthorizationPermissionsResponse = {
  authorizationGrants: Array<EntityAuthorizationGrant>;
  hasMore: boolean;
};

export type QueryEntityPermissionsResponse = {
  hasMore: boolean;
  permissions: Array<EntityPermissionItem>;
};

export type QueryEntityRolesResponse = {
  hasMore: boolean;
  roles: Array<EntityRole>;
};

export type QueryEuEntityPermissionsResponse = {
  hasMore: boolean;
  permissions: Array<EuEntityPermission>;
};

export type QueryInvoicesMetadataResponse = {
  hasMore: boolean;
  invoices: Array<InvoiceMetadata>;
  isTruncated: boolean;
  permanentStorageHwmDate?: string | null;
};

export type QueryPeppolProvidersResponse = {
  hasMore: boolean;
  peppolProviders: Array<PeppolProvider>;
};

export type QueryPersonalPermissionsResponse = {
  hasMore: boolean;
  permissions: Array<PersonalPermission>;
};

export type QueryPersonPermissionsResponse = {
  hasMore: boolean;
  permissions: Array<PersonPermission>;
};

export type QuerySubordinateEntityRolesResponse = {
  hasMore: boolean;
  roles: Array<SubordinateEntityRole>;
};

export type QuerySubunitPermissionsResponse = {
  hasMore: boolean;
  permissions: Array<SubunitPermission>;
};

export type QueryTokensResponse = {
  continuationToken?: string | null;
  tokens: Array<QueryTokensResponseItem>;
};

export type QueryTokensResponseItem = {
  authorIdentifier: TokenAuthorIdentifierTypeIdentifier;
  contextIdentifier: TokenContextIdentifierTypeIdentifier;
  dateCreated: string;
  description: string;
  lastUseDate?: string | null;
  referenceNumber: ReferenceNumber;
  requestedPermissions: Array<TokenPermissionType>;
  status: AuthenticationTokenStatus;
  statusDetails?: Array<string> | null;
};

export type QueryType = "Granted" | "Received";

export type ReferenceNumber = string;

export type RetrieveCertificatesListItem = {
  certificate: string;
  certificateName: string;
  certificateSerialNumber: string;
  certificateType: KsefCertificateType;
};

export type RetrieveCertificatesRequest = {
  certificateSerialNumbers: Array<string>;
};

export type RetrieveCertificatesResponse = {
  certificates: Array<RetrieveCertificatesListItem>;
};

export type RetryAfter = number;

export type RevokeCertificateRequest = {
  revocationReason?: CertificateRevocationReason | null;
};

export type SendInvoiceRequest = {
  encryptedInvoiceContent: string;
  encryptedInvoiceHash: Sha256HashBase64;
  encryptedInvoiceSize: number;
  hashOfCorrectedInvoice?: Sha256HashBase64 | null;
  invoiceHash: Sha256HashBase64;
  invoiceSize: number;
  offlineMode?: boolean;
};

export type SendInvoiceResponse = {
  referenceNumber: ReferenceNumber;
};

export type SessionInvoicesResponse = {
  continuationToken?: string | null;
  invoices: Array<SessionInvoiceStatusResponse>;
};

export type SessionInvoiceStatusResponse = {
  acquisitionDate?: string | null;
  invoiceFileName?: string | null;
  invoiceHash: Sha256HashBase64;
  invoiceNumber?: string | null;
  invoicingDate: string;
  invoicingMode?: InvoicingMode | null;
  ksefNumber?: KsefNumber | null;
  ordinalNumber: number;
  permanentStorageDate?: string | null;
  referenceNumber: ReferenceNumber;
  status: InvoiceStatusInfo;
  upoDownloadUrl?: string | null;
  upoDownloadUrlExpirationDate?: string | null;
};

export type SessionsQueryResponse = {
  continuationToken?: string | null;
  sessions: Array<SessionsQueryResponseItem>;
};

export type SessionsQueryResponseItem = {
  dateCreated: string;
  dateUpdated: string;
  failedInvoiceCount: number;
  referenceNumber: ReferenceNumber;
  status: StatusInfo;
  successfulInvoiceCount: number;
  totalInvoiceCount: number;
  validUntil?: string | null;
};

export type SessionStatusResponse = {
  dateCreated: string;
  dateUpdated: string;
  failedInvoiceCount?: number | null;
  invoiceCount?: number | null;
  status: StatusInfo;
  successfulInvoiceCount?: number | null;
  upo?: UpoResponse | null;
  validUntil?: string | null;
};

export type SessionType = "Batch" | "Online";

export type SetRateLimitsRequest = {
  rateLimits: ApiRateLimitsOverride;
};

export type SetSessionLimitsRequest = {
  batchSession: BatchSessionContextLimitsOverride;
  collectiveIdentifier: CollectiveIdentifierContextLimitsOverride;
  onlineSession: OnlineSessionContextLimitsOverride;
};

export type SetSubjectLimitsRequest = {
  certificate?: CertificateSubjectLimitsOverride | null;
  enrollment?: EnrollmentSubjectLimitsOverride | null;
  subjectIdentifierType?: SubjectIdentifierType;
};

export type Sha256HashBase64 = string;

export type SortOrder = "Asc" | "Desc";

export type StatusInfo = {
  code: number;
  description: string;
  details?: Array<string> | null;
};

export type SubjectCreateRequest = {
  createdDate?: string | null;
  description: string;
  subjectNip: Nip;
  subjectType: SubjectType;
  subunits?: Array<Subunit> | null;
};

export type SubjectIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type SubjectRemoveRequest = {
  subjectNip: Nip;
};

export type SubjectType = "EnforcementAuthority" | "JST" | "VatGroup";

export type SubordinateEntityRole = {
  description: string;
  role: SubordinateEntityRoleType;
  startDate: string;
  subordinateEntityIdentifier: SubordinateRoleSubordinateEntityIdentifier;
};

export type SubordinateEntityRolesQueryRequest = {
  subordinateEntityIdentifier?: EntityPermissionsSubordinateEntityIdentifier | null;
};

export type SubordinateEntityRoleType = "LocalGovernmentSubUnit" | "VatGroupSubUnit";

export type SubordinateRoleSubordinateEntityIdentifier = {
  type: SubordinateRoleSubordinateEntityIdentifierType;
  value: string;
};

export type SubordinateRoleSubordinateEntityIdentifierType = "Nip";

export type Subunit = {
  description: string;
  subjectNip: Nip;
};

export type SubunitPermission = {
  authorIdentifier: SubunitPermissionsAuthorIdentifier;
  authorizedIdentifier: SubunitPermissionsAuthorizedIdentifier;
  description: string;
  id: PermissionId;
  permissionScope: SubunitPermissionScope;
  startDate: string;
  subjectPersonDetails?: PermissionsSubjectPersonDetails | null;
  subunitIdentifier: SubunitPermissionsSubunitIdentifier;
  subunitName?: string | null;
};

export type SubunitPermissionsAuthorIdentifier = {
  type: SubunitPermissionsAuthorIdentifierType;
  value: string;
};

export type SubunitPermissionsAuthorIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type SubunitPermissionsAuthorizedIdentifier = {
  type: SubunitPermissionsSubjectIdentifierType;
  value: string;
};

export type SubunitPermissionsContextIdentifier = {
  type: SubunitPermissionsContextIdentifierType;
  value: string;
};

export type SubunitPermissionsContextIdentifierType = "InternalId" | "Nip";

export type SubunitPermissionScope = "CredentialsManage";

export type SubunitPermissionsGrantRequest = {
  contextIdentifier: SubunitPermissionsContextIdentifier;
  description: string;
  subjectDetails: PersonPermissionSubjectDetails;
  subjectIdentifier: SubunitPermissionsSubjectIdentifier;
  subunitName?: string | null;
};

export type SubunitPermissionsQueryRequest = {
  subunitIdentifier?: SubunitPermissionsSubunitIdentifier | null;
};

export type SubunitPermissionsSubjectIdentifier = {
  type: SubunitPermissionsSubjectIdentifierType;
  value: string;
};

export type SubunitPermissionsSubjectIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type SubunitPermissionsSubunitIdentifier = {
  type: SubunitPermissionsSubunitIdentifierType;
  value: string;
};

export type SubunitPermissionsSubunitIdentifierType = "InternalId" | "Nip";

export type SystemWarning = string;

export type TestDataAuthenticationContextIdentifier = {
  type: TestDataAuthenticationContextIdentifierType;
  value: string;
};

export type TestDataAuthenticationContextIdentifierType = "InternalId" | "Nip" | "NipVatUe" | "PeppolId";

export type TestDataAuthorizedIdentifier = {
  type: TestDataAuthorizedIdentifierType;
  value: string;
};

export type TestDataAuthorizedIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type TestDataContextIdentifier = {
  type: TestDataContextIdentifierType;
  value: string;
};

export type TestDataContextIdentifierType = "Nip";

export type TestDataPermission = {
  description: string;
  permissionType: TestDataPermissionType;
};

export type TestDataPermissionsGrantRequest = {
  authorizedIdentifier: TestDataAuthorizedIdentifier;
  contextIdentifier: TestDataContextIdentifier;
  permissions: Array<TestDataPermission>;
};

export type TestDataPermissionsRevokeRequest = {
  authorizedIdentifier: TestDataAuthorizedIdentifier;
  contextIdentifier: TestDataContextIdentifier;
};

export type TestDataPermissionType = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage";

export type TestDataUpdateCertificateRequest = {
  validTo: string;
};

export type ThirdSubjectIdentifierType = "InternalId" | "Nip" | "None" | "Other" | "VatUe";

export type TokenAuthorIdentifierType = "Fingerprint" | "Nip" | "Pesel";

export type TokenAuthorIdentifierTypeIdentifier = {
  type: TokenAuthorIdentifierType;
  value: string;
};

export type TokenContextIdentifierType = "InternalId" | "Nip" | "NipVatUe" | "PeppolId";

export type TokenContextIdentifierTypeIdentifier = {
  type: TokenContextIdentifierType;
  value: string;
};

export type TokenInfo = {
  token: string;
  validUntil: string;
};

export type TokenPermissionType = "CollectiveIdentifierManage" | "CredentialsManage" | "CredentialsRead" | "EnforcementOperations" | "Introspection" | "InvoiceRead" | "InvoiceWrite" | "SubunitManage";

export type TokenStatusResponse = {
  authorIdentifier: TokenAuthorIdentifierTypeIdentifier;
  contextIdentifier: TokenContextIdentifierTypeIdentifier;
  dateCreated: string;
  description: string;
  lastUseDate?: string | null;
  referenceNumber: ReferenceNumber;
  requestedPermissions: Array<TokenPermissionType>;
  status: AuthenticationTokenStatus;
  statusDetails?: Array<string> | null;
};

export type TooManyRequestsProblemDetails = {
  detail: string;
  instance: string;
  status: number;
  timestamp: string;
  title: string;
  traceId: string;
};

export type TooManyRequestsResponse = {
  status: {
    code: number;
    description: string;
    details: Array<string>;
  };
};

export type UnauthorizedProblemDetails = {
  detail: string;
  instance?: string | null;
  status: number;
  timestamp: string;
  title: string;
  traceId?: string | null;
};

export type UnblockContextAuthenticationRequest = {
  contextIdentifier?: TestDataAuthenticationContextIdentifier | null;
};

export type UpoPageResponse = {
  downloadUrl: string;
  downloadUrlExpirationDate: string;
  referenceNumber: ReferenceNumber;
};

export type UpoResponse = {
  pages: Array<UpoPageResponse>;
};

export interface OpenApiGeneratedSchemaMap {
  AllowedIps: AllowedIps;
  AmountType: AmountType;
  ApiError: ApiError;
  ApiRateLimitsOverride: ApiRateLimitsOverride;
  ApiRateLimitValuesOverride: ApiRateLimitValuesOverride;
  AttachmentPermissionGrantRequest: AttachmentPermissionGrantRequest;
  AttachmentPermissionRevokeRequest: AttachmentPermissionRevokeRequest;
  AuthenticationChallengeResponse: AuthenticationChallengeResponse;
  AuthenticationContextIdentifier: AuthenticationContextIdentifier;
  AuthenticationContextIdentifierType: AuthenticationContextIdentifierType;
  AuthenticationInitResponse: AuthenticationInitResponse;
  AuthenticationListItem: AuthenticationListItem;
  AuthenticationListResponse: AuthenticationListResponse;
  AuthenticationMethod: AuthenticationMethod;
  AuthenticationMethodCategory: AuthenticationMethodCategory;
  AuthenticationMethodInfo: AuthenticationMethodInfo;
  AuthenticationOperationStatusResponse: AuthenticationOperationStatusResponse;
  AuthenticationTokenRefreshResponse: AuthenticationTokenRefreshResponse;
  AuthenticationTokensResponse: AuthenticationTokensResponse;
  AuthenticationTokenStatus: AuthenticationTokenStatus;
  AuthorizationPolicy: AuthorizationPolicy;
  BadRequestProblemDetails: BadRequestProblemDetails;
  BatchFileInfo: BatchFileInfo;
  BatchFilePartInfo: BatchFilePartInfo;
  BatchSessionContextLimitsOverride: BatchSessionContextLimitsOverride;
  BatchSessionEffectiveContextLimits: BatchSessionEffectiveContextLimits;
  BlockContextAuthenticationRequest: BlockContextAuthenticationRequest;
  BuyerIdentifierType: BuyerIdentifierType;
  CertificateEffectiveSubjectLimits: CertificateEffectiveSubjectLimits;
  CertificateEnrollmentDataResponse: CertificateEnrollmentDataResponse;
  CertificateEnrollmentStatusResponse: CertificateEnrollmentStatusResponse;
  CertificateLimit: CertificateLimit;
  CertificateLimitsResponse: CertificateLimitsResponse;
  CertificateListItem: CertificateListItem;
  CertificateListItemStatus: CertificateListItemStatus;
  CertificateRevocationReason: CertificateRevocationReason;
  CertificateSubjectIdentifier: CertificateSubjectIdentifier;
  CertificateSubjectIdentifierType: CertificateSubjectIdentifierType;
  CertificateSubjectLimitsOverride: CertificateSubjectLimitsOverride;
  Challenge: Challenge;
  CheckAttachmentPermissionStatusResponse: CheckAttachmentPermissionStatusResponse;
  CollectiveIdentifierContextLimitsOverride: CollectiveIdentifierContextLimitsOverride;
  CollectiveIdentifierEffectiveContextLimits: CollectiveIdentifierEffectiveContextLimits;
  CollectiveIdentifierInvoice: CollectiveIdentifierInvoice;
  CollectiveIdentifierInvoicePayment: CollectiveIdentifierInvoicePayment;
  CollectiveIdentifierInvoicesQueryRequest: CollectiveIdentifierInvoicesQueryRequest;
  CollectiveIdentifierInvoicesQueryResponse: CollectiveIdentifierInvoicesQueryResponse;
  CollectiveIdentifierInvoicesQueryResponseItem: CollectiveIdentifierInvoicesQueryResponseItem;
  CollectiveIdentifierInvoicesQueryResponseItemPayment: CollectiveIdentifierInvoicesQueryResponseItemPayment;
  CollectiveIdentifiersByKsefNumberQueryResponse: CollectiveIdentifiersByKsefNumberQueryResponse;
  CollectiveIdentifiersByKsefNumberQueryResponseItem: CollectiveIdentifiersByKsefNumberQueryResponseItem;
  CollectiveIdentifiersQueryRequest: CollectiveIdentifiersQueryRequest;
  CollectiveIdentifiersQueryResponse: CollectiveIdentifiersQueryResponse;
  CollectiveIdentifiersQueryResponseItem: CollectiveIdentifiersQueryResponseItem;
  CommonSessionStatus: CommonSessionStatus;
  CompressionType: CompressionType;
  CurrencyCode: CurrencyCode;
  EffectiveApiRateLimits: EffectiveApiRateLimits;
  EffectiveApiRateLimitValues: EffectiveApiRateLimitValues;
  EffectiveContextLimits: EffectiveContextLimits;
  EffectiveSubjectLimits: EffectiveSubjectLimits;
  EncryptionInfo: EncryptionInfo;
  EnrollCertificateRequest: EnrollCertificateRequest;
  EnrollCertificateResponse: EnrollCertificateResponse;
  EnrollmentEffectiveSubjectLimits: EnrollmentEffectiveSubjectLimits;
  EnrollmentSubjectLimitsOverride: EnrollmentSubjectLimitsOverride;
  EntityAuthorizationGrant: EntityAuthorizationGrant;
  EntityAuthorizationPermissionsGrantRequest: EntityAuthorizationPermissionsGrantRequest;
  EntityAuthorizationPermissionsQueryRequest: EntityAuthorizationPermissionsQueryRequest;
  EntityAuthorizationPermissionsSubjectIdentifier: EntityAuthorizationPermissionsSubjectIdentifier;
  EntityAuthorizationPermissionsSubjectIdentifierType: EntityAuthorizationPermissionsSubjectIdentifierType;
  EntityAuthorizationPermissionType: EntityAuthorizationPermissionType;
  EntityAuthorizationsAuthorIdentifier: EntityAuthorizationsAuthorIdentifier;
  EntityAuthorizationsAuthorIdentifierType: EntityAuthorizationsAuthorIdentifierType;
  EntityAuthorizationsAuthorizedEntityIdentifier: EntityAuthorizationsAuthorizedEntityIdentifier;
  EntityAuthorizationsAuthorizedEntityIdentifierType: EntityAuthorizationsAuthorizedEntityIdentifierType;
  EntityAuthorizationsAuthorizingEntityIdentifier: EntityAuthorizationsAuthorizingEntityIdentifier;
  EntityAuthorizationsAuthorizingEntityIdentifierType: EntityAuthorizationsAuthorizingEntityIdentifierType;
  EntityByFingerprintDetails: EntityByFingerprintDetails;
  EntityDetails: EntityDetails;
  EntityPermission: EntityPermission;
  EntityPermissionItem: EntityPermissionItem;
  EntityPermissionItemScope: EntityPermissionItemScope;
  EntityPermissionsContextIdentifier: EntityPermissionsContextIdentifier;
  EntityPermissionsContextIdentifierType: EntityPermissionsContextIdentifierType;
  EntityPermissionsGrantRequest: EntityPermissionsGrantRequest;
  EntityPermissionsQueryRequest: EntityPermissionsQueryRequest;
  EntityPermissionsSubjectIdentifier: EntityPermissionsSubjectIdentifier;
  EntityPermissionsSubjectIdentifierType: EntityPermissionsSubjectIdentifierType;
  EntityPermissionsSubordinateEntityIdentifier: EntityPermissionsSubordinateEntityIdentifier;
  EntityPermissionsSubordinateEntityIdentifierType: EntityPermissionsSubordinateEntityIdentifierType;
  EntityPermissionType: EntityPermissionType;
  EntityRole: EntityRole;
  EntityRolesParentEntityIdentifier: EntityRolesParentEntityIdentifier;
  EntityRolesParentEntityIdentifierType: EntityRolesParentEntityIdentifierType;
  EntityRoleType: EntityRoleType;
  EntitySubjectByFingerprintDetailsType: EntitySubjectByFingerprintDetailsType;
  EntitySubjectByIdentifierDetailsType: EntitySubjectByIdentifierDetailsType;
  EntitySubjectDetailsType: EntitySubjectDetailsType;
  EuEntityAdministrationPermissionsContextIdentifier: EuEntityAdministrationPermissionsContextIdentifier;
  EuEntityAdministrationPermissionsContextIdentifierType: EuEntityAdministrationPermissionsContextIdentifierType;
  EuEntityAdministrationPermissionsGrantRequest: EuEntityAdministrationPermissionsGrantRequest;
  EuEntityAdministrationPermissionsSubjectIdentifier: EuEntityAdministrationPermissionsSubjectIdentifier;
  EuEntityAdministrationPermissionsSubjectIdentifierType: EuEntityAdministrationPermissionsSubjectIdentifierType;
  EuEntityDetails: EuEntityDetails;
  EuEntityPermission: EuEntityPermission;
  EuEntityPermissionsAuthorIdentifier: EuEntityPermissionsAuthorIdentifier;
  EuEntityPermissionsAuthorIdentifierType: EuEntityPermissionsAuthorIdentifierType;
  EuEntityPermissionsGrantRequest: EuEntityPermissionsGrantRequest;
  EuEntityPermissionsQueryPermissionType: EuEntityPermissionsQueryPermissionType;
  EuEntityPermissionsQueryRequest: EuEntityPermissionsQueryRequest;
  EuEntityPermissionsSubjectIdentifier: EuEntityPermissionsSubjectIdentifier;
  EuEntityPermissionsSubjectIdentifierType: EuEntityPermissionsSubjectIdentifierType;
  EuEntityPermissionSubjectDetails: EuEntityPermissionSubjectDetails;
  EuEntityPermissionSubjectDetailsType: EuEntityPermissionSubjectDetailsType;
  EuEntityPermissionType: EuEntityPermissionType;
  ExceptionDetails: ExceptionDetails;
  ExceptionInfo: ExceptionInfo;
  ExceptionResponse: ExceptionResponse;
  ExportInvoicesResponse: ExportInvoicesResponse;
  ForbiddenProblemDetails: ForbiddenProblemDetails;
  FormCode: FormCode;
  GenerateCollectiveIdentifierRequest: GenerateCollectiveIdentifierRequest;
  GenerateCollectiveIdentifierResponse: GenerateCollectiveIdentifierResponse;
  GenerateTokenRequest: GenerateTokenRequest;
  GenerateTokenResponse: GenerateTokenResponse;
  GoneProblemDetails: GoneProblemDetails;
  IdDocument: IdDocument;
  IndirectPermissionsGrantRequest: IndirectPermissionsGrantRequest;
  IndirectPermissionsSubjectIdentifier: IndirectPermissionsSubjectIdentifier;
  IndirectPermissionsSubjectIdentifierType: IndirectPermissionsSubjectIdentifierType;
  IndirectPermissionsTargetIdentifier: IndirectPermissionsTargetIdentifier;
  IndirectPermissionsTargetIdentifierType: IndirectPermissionsTargetIdentifierType;
  IndirectPermissionType: IndirectPermissionType;
  InitTokenAuthenticationRequest: InitTokenAuthenticationRequest;
  InternalId: InternalId;
  InvoiceExportRequest: InvoiceExportRequest;
  InvoiceExportStatusResponse: InvoiceExportStatusResponse;
  InvoiceMetadata: InvoiceMetadata;
  InvoiceMetadataAuthorizedSubject: InvoiceMetadataAuthorizedSubject;
  InvoiceMetadataBuyer: InvoiceMetadataBuyer;
  InvoiceMetadataBuyerIdentifier: InvoiceMetadataBuyerIdentifier;
  InvoiceMetadataSeller: InvoiceMetadataSeller;
  InvoiceMetadataThirdSubject: InvoiceMetadataThirdSubject;
  InvoiceMetadataThirdSubjectIdentifier: InvoiceMetadataThirdSubjectIdentifier;
  InvoicePackage: InvoicePackage;
  InvoicePackagePart: InvoicePackagePart;
  InvoicePermissionType: InvoicePermissionType;
  InvoiceQueryAmount: InvoiceQueryAmount;
  InvoiceQueryBuyerIdentifier: InvoiceQueryBuyerIdentifier;
  InvoiceQueryDateRange: InvoiceQueryDateRange;
  InvoiceQueryDateType: InvoiceQueryDateType;
  InvoiceQueryFilters: InvoiceQueryFilters;
  InvoiceQueryFormType: InvoiceQueryFormType;
  InvoiceQuerySubjectType: InvoiceQuerySubjectType;
  InvoiceStatusInfo: InvoiceStatusInfo;
  InvoiceType: InvoiceType;
  InvoicingMode: InvoicingMode;
  KsefCertificateType: KsefCertificateType;
  KsefNumber: KsefNumber;
  Nip: Nip;
  NipVatUe: NipVatUe;
  OnlineSessionContextLimitsOverride: OnlineSessionContextLimitsOverride;
  OnlineSessionEffectiveContextLimits: OnlineSessionEffectiveContextLimits;
  OpenBatchSessionRequest: OpenBatchSessionRequest;
  OpenBatchSessionResponse: OpenBatchSessionResponse;
  OpenOnlineSessionRequest: OpenOnlineSessionRequest;
  OpenOnlineSessionResponse: OpenOnlineSessionResponse;
  PartUploadRequest: PartUploadRequest;
  PeppolId: PeppolId;
  PeppolProvider: PeppolProvider;
  PermissionId: PermissionId;
  PermissionsEuEntityDetails: PermissionsEuEntityDetails;
  PermissionsOperationResponse: PermissionsOperationResponse;
  PermissionsOperationStatusResponse: PermissionsOperationStatusResponse;
  PermissionsSubjectEntityByFingerprintDetails: PermissionsSubjectEntityByFingerprintDetails;
  PermissionsSubjectEntityByIdentifierDetails: PermissionsSubjectEntityByIdentifierDetails;
  PermissionsSubjectEntityDetails: PermissionsSubjectEntityDetails;
  PermissionsSubjectPersonByFingerprintDetails: PermissionsSubjectPersonByFingerprintDetails;
  PermissionsSubjectPersonDetails: PermissionsSubjectPersonDetails;
  PermissionState: PermissionState;
  PersonalPermission: PersonalPermission;
  PersonalPermissionsAuthorizedIdentifier: PersonalPermissionsAuthorizedIdentifier;
  PersonalPermissionsAuthorizedIdentifierType: PersonalPermissionsAuthorizedIdentifierType;
  PersonalPermissionsContextIdentifier: PersonalPermissionsContextIdentifier;
  PersonalPermissionsContextIdentifierType: PersonalPermissionsContextIdentifierType;
  PersonalPermissionScope: PersonalPermissionScope;
  PersonalPermissionsQueryRequest: PersonalPermissionsQueryRequest;
  PersonalPermissionsTargetIdentifier: PersonalPermissionsTargetIdentifier;
  PersonalPermissionsTargetIdentifierType: PersonalPermissionsTargetIdentifierType;
  PersonalPermissionType: PersonalPermissionType;
  PersonByFingerprintWithIdentifierDetails: PersonByFingerprintWithIdentifierDetails;
  PersonByFingerprintWithoutIdentifierDetails: PersonByFingerprintWithoutIdentifierDetails;
  PersonCreateRequest: PersonCreateRequest;
  PersonDetails: PersonDetails;
  PersonIdentifier: PersonIdentifier;
  PersonIdentifierType: PersonIdentifierType;
  PersonPermission: PersonPermission;
  PersonPermissionsAuthorIdentifier: PersonPermissionsAuthorIdentifier;
  PersonPermissionsAuthorIdentifierType: PersonPermissionsAuthorIdentifierType;
  PersonPermissionsAuthorizedIdentifier: PersonPermissionsAuthorizedIdentifier;
  PersonPermissionsAuthorizedIdentifierType: PersonPermissionsAuthorizedIdentifierType;
  PersonPermissionsContextIdentifier: PersonPermissionsContextIdentifier;
  PersonPermissionsContextIdentifierType: PersonPermissionsContextIdentifierType;
  PersonPermissionScope: PersonPermissionScope;
  PersonPermissionsGrantRequest: PersonPermissionsGrantRequest;
  PersonPermissionsQueryRequest: PersonPermissionsQueryRequest;
  PersonPermissionsQueryType: PersonPermissionsQueryType;
  PersonPermissionsSubjectIdentifier: PersonPermissionsSubjectIdentifier;
  PersonPermissionsSubjectIdentifierType: PersonPermissionsSubjectIdentifierType;
  PersonPermissionsTargetIdentifier: PersonPermissionsTargetIdentifier;
  PersonPermissionsTargetIdentifierType: PersonPermissionsTargetIdentifierType;
  PersonPermissionSubjectDetails: PersonPermissionSubjectDetails;
  PersonPermissionSubjectDetailsType: PersonPermissionSubjectDetailsType;
  PersonPermissionType: PersonPermissionType;
  PersonRemoveRequest: PersonRemoveRequest;
  PersonSubjectByFingerprintDetailsType: PersonSubjectByFingerprintDetailsType;
  PersonSubjectDetailsType: PersonSubjectDetailsType;
  Pesel: Pesel;
  PublicKeyCertificate: PublicKeyCertificate;
  PublicKeyCertificateUsage: PublicKeyCertificateUsage;
  QueryCertificatesRequest: QueryCertificatesRequest;
  QueryCertificatesResponse: QueryCertificatesResponse;
  QueryEntityAuthorizationPermissionsResponse: QueryEntityAuthorizationPermissionsResponse;
  QueryEntityPermissionsResponse: QueryEntityPermissionsResponse;
  QueryEntityRolesResponse: QueryEntityRolesResponse;
  QueryEuEntityPermissionsResponse: QueryEuEntityPermissionsResponse;
  QueryInvoicesMetadataResponse: QueryInvoicesMetadataResponse;
  QueryPeppolProvidersResponse: QueryPeppolProvidersResponse;
  QueryPersonalPermissionsResponse: QueryPersonalPermissionsResponse;
  QueryPersonPermissionsResponse: QueryPersonPermissionsResponse;
  QuerySubordinateEntityRolesResponse: QuerySubordinateEntityRolesResponse;
  QuerySubunitPermissionsResponse: QuerySubunitPermissionsResponse;
  QueryTokensResponse: QueryTokensResponse;
  QueryTokensResponseItem: QueryTokensResponseItem;
  QueryType: QueryType;
  ReferenceNumber: ReferenceNumber;
  RetrieveCertificatesListItem: RetrieveCertificatesListItem;
  RetrieveCertificatesRequest: RetrieveCertificatesRequest;
  RetrieveCertificatesResponse: RetrieveCertificatesResponse;
  RetryAfter: RetryAfter;
  RevokeCertificateRequest: RevokeCertificateRequest;
  SendInvoiceRequest: SendInvoiceRequest;
  SendInvoiceResponse: SendInvoiceResponse;
  SessionInvoicesResponse: SessionInvoicesResponse;
  SessionInvoiceStatusResponse: SessionInvoiceStatusResponse;
  SessionsQueryResponse: SessionsQueryResponse;
  SessionsQueryResponseItem: SessionsQueryResponseItem;
  SessionStatusResponse: SessionStatusResponse;
  SessionType: SessionType;
  SetRateLimitsRequest: SetRateLimitsRequest;
  SetSessionLimitsRequest: SetSessionLimitsRequest;
  SetSubjectLimitsRequest: SetSubjectLimitsRequest;
  Sha256HashBase64: Sha256HashBase64;
  SortOrder: SortOrder;
  StatusInfo: StatusInfo;
  SubjectCreateRequest: SubjectCreateRequest;
  SubjectIdentifierType: SubjectIdentifierType;
  SubjectRemoveRequest: SubjectRemoveRequest;
  SubjectType: SubjectType;
  SubordinateEntityRole: SubordinateEntityRole;
  SubordinateEntityRolesQueryRequest: SubordinateEntityRolesQueryRequest;
  SubordinateEntityRoleType: SubordinateEntityRoleType;
  SubordinateRoleSubordinateEntityIdentifier: SubordinateRoleSubordinateEntityIdentifier;
  SubordinateRoleSubordinateEntityIdentifierType: SubordinateRoleSubordinateEntityIdentifierType;
  Subunit: Subunit;
  SubunitPermission: SubunitPermission;
  SubunitPermissionsAuthorIdentifier: SubunitPermissionsAuthorIdentifier;
  SubunitPermissionsAuthorIdentifierType: SubunitPermissionsAuthorIdentifierType;
  SubunitPermissionsAuthorizedIdentifier: SubunitPermissionsAuthorizedIdentifier;
  SubunitPermissionsContextIdentifier: SubunitPermissionsContextIdentifier;
  SubunitPermissionsContextIdentifierType: SubunitPermissionsContextIdentifierType;
  SubunitPermissionScope: SubunitPermissionScope;
  SubunitPermissionsGrantRequest: SubunitPermissionsGrantRequest;
  SubunitPermissionsQueryRequest: SubunitPermissionsQueryRequest;
  SubunitPermissionsSubjectIdentifier: SubunitPermissionsSubjectIdentifier;
  SubunitPermissionsSubjectIdentifierType: SubunitPermissionsSubjectIdentifierType;
  SubunitPermissionsSubunitIdentifier: SubunitPermissionsSubunitIdentifier;
  SubunitPermissionsSubunitIdentifierType: SubunitPermissionsSubunitIdentifierType;
  SystemWarning: SystemWarning;
  TestDataAuthenticationContextIdentifier: TestDataAuthenticationContextIdentifier;
  TestDataAuthenticationContextIdentifierType: TestDataAuthenticationContextIdentifierType;
  TestDataAuthorizedIdentifier: TestDataAuthorizedIdentifier;
  TestDataAuthorizedIdentifierType: TestDataAuthorizedIdentifierType;
  TestDataContextIdentifier: TestDataContextIdentifier;
  TestDataContextIdentifierType: TestDataContextIdentifierType;
  TestDataPermission: TestDataPermission;
  TestDataPermissionsGrantRequest: TestDataPermissionsGrantRequest;
  TestDataPermissionsRevokeRequest: TestDataPermissionsRevokeRequest;
  TestDataPermissionType: TestDataPermissionType;
  TestDataUpdateCertificateRequest: TestDataUpdateCertificateRequest;
  ThirdSubjectIdentifierType: ThirdSubjectIdentifierType;
  TokenAuthorIdentifierType: TokenAuthorIdentifierType;
  TokenAuthorIdentifierTypeIdentifier: TokenAuthorIdentifierTypeIdentifier;
  TokenContextIdentifierType: TokenContextIdentifierType;
  TokenContextIdentifierTypeIdentifier: TokenContextIdentifierTypeIdentifier;
  TokenInfo: TokenInfo;
  TokenPermissionType: TokenPermissionType;
  TokenStatusResponse: TokenStatusResponse;
  TooManyRequestsProblemDetails: TooManyRequestsProblemDetails;
  TooManyRequestsResponse: TooManyRequestsResponse;
  UnauthorizedProblemDetails: UnauthorizedProblemDetails;
  UnblockContextAuthenticationRequest: UnblockContextAuthenticationRequest;
  UpoPageResponse: UpoPageResponse;
  UpoResponse: UpoResponse;
}

export type OpenApiGeneratedSchemaName = keyof OpenApiGeneratedSchemaMap;

